import { ApiKeyCursor, ApiKeyScope, ApiKeysData, ApiKeysDto, GenerateApiKeyResponse, toApiKey } from "domain/apiKeys";
import { apiGatewayService } from "services/api/ApiGatewayService";

const API_KEYS_PATH = "/api/api-keys";
export interface ApiKeyData {
    apiKeys: ApiKeysData[];
}

export interface ApiKeyCursorDto {
    public_uuid: string;
}

interface ApiKeysResponseDto {
    api_keys: ApiKeysDto[];
    cursor: ApiKeyCursorDto;
}

interface ApiKeyDto {
    api_key: string;
}

function ToApiKeyGet(dto: ApiKeyDto): GenerateApiKeyResponse {
    return {
        apiKey: dto.api_key,
    };
}

function toKeyCursor(dto: ApiKeyCursorDto): ApiKeyCursor | null {
    return dto == null
        ? null
        : {
              publicUuid: dto.public_uuid,
          };
}

class ApiKeysService {
    public fetchApiKeys(
        owned: boolean,
        abortController: AbortController,
        publicUuid?: string,
        search?: string
    ): Promise<ApiKeysData> {
        const urlSearchParams = new URLSearchParams();
        const PATH_API_KEYS = "/api/api-keys?owned=" + owned;
        if (search != undefined && search != "") {
            urlSearchParams.append("search", search);
        }

        if (publicUuid != undefined && publicUuid != "" && publicUuid != null) {
            urlSearchParams.append("public_uuid", publicUuid);
        }

        const param = urlSearchParams.toString();
        let api_url = PATH_API_KEYS;
        if (param !== "") {
            api_url += "&" + param;
        }
        return apiGatewayService
            .invokeApi(api_url, "GET", null, { abortSignal: abortController.signal })
            .then((response: ApiKeysResponseDto) => {
                const apiKeys = response.api_keys.map(toApiKey);
                const cursor = toKeyCursor(response.cursor);
                return {
                    apiKeys: {
                        api_keys: apiKeys,
                        cursor: cursor,
                    },
                };
            });
    }

    public deleteApiKey(public_uuid: string, abortController: AbortController): Promise<void> {
        return apiGatewayService.invokeApi(
            API_KEYS_PATH + "/delete",
            "POST",
            { public_uuid },
            {
                abortSignal: abortController.signal,
            }
        );
    }

    public editApiKey(
        public_uuid: string,
        name: string,
        description: string,
        abortController: AbortController
    ): Promise<void> {
        const postData = { name, description, public_uuid };
        return apiGatewayService.invokeApi(API_KEYS_PATH + "/edit", "POST", postData, {
            abortSignal: abortController.signal,
        });
    }

    public generateApiKey(
        name: string,
        description: string,
        expiration: string | undefined,
        scope: ApiKeyScope,
        abortController: AbortController
    ): Promise<GenerateApiKeyResponse> {
        const postData: { name: string; description: string; expiration?: string; scope: ApiKeyScope } = {
            name,
            description,
            scope,
        };
        if (expiration != null) {
            postData.expiration = expiration;
        }
        return apiGatewayService
            .invokeApi(API_KEYS_PATH, "POST", postData, { abortSignal: abortController.signal })
            .then((dtos: ApiKeyDto) => ToApiKeyGet(dtos));
    }
}

export const apiKeysService = new ApiKeysService();
